import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { TEXTS } from '../core/texts';

export interface IConfirmationDialogState {
  open: boolean;
  text: string;
  cb: (args?: any) => void;
  openDialog: (args: { text?: string, cb: (args?: any) => void }) => void;
  closeDialog: () => void;
}

const initialState = {
  open: false,
  text: '',
  cb: () => {},
};

export const useConfirmationDialog = create<IConfirmationDialogState>()(devtools((set, getState) => ({
  ...initialState,
  openDialog: ({ text = TEXTS.CONFIRMATION_DELETE, cb }) => {
    set(prev => ({ ...prev, open: true, text, cb }));
  },
  closeDialog: () => {
    set(prev => ({ ...prev, ...initialState }));
  }
})));